import React, { KeyboardEventHandler, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import { components, OptionProps } from 'react-select';
import './styles.scss';

export type SelectOptions = {
  label: string;
  value: string;
  count?: string;
};

export type MultiSelectProps = {
  id?: string;
  placeholder?: string;
  wrapperClassName?: string;
  label?: string;
  labelClassName?: string;
  value?: SelectOptions[];
  name?: string;
  onChange?: (value: SelectOptions[], name?: string) => void;
  options: SelectOptions[];
  styles?: Record<string, any>;
  state?: 'error' | 'success' | 'gray' | 'default';
  errorText?: string;
  bottomText?: string;
  bottomTextClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
};

const createOption = (label: string) => ({
  label,
  value: label,
});

export const MMultiSelect: React.FC<MultiSelectProps> = ({
  id,
  placeholder,
  wrapperClassName,
  label,
  labelClassName,
  name,
  value,
  onChange,
  options,
  styles = {},
  state,
  errorText,
  bottomText,
  bottomTextClassName,
  inputClassName,
  disabled,
  size = 'md',
}) => {
  const [inputValue, setInputValue] = React.useState('');
  const [val, setVal] = React.useState<readonly SelectOptions[]>([]);

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setVal((prev) => [...prev, createOption(inputValue)]);
        setInputValue('');
        onChange?.([...val, createOption(inputValue)], name);
        event.preventDefault();
    }
  };

  useEffect(() => {
    value && setVal(value);
  }, [value]);

  // custom option
  const Option = (props: OptionProps<SelectOptions>) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {props.data.label}
          {props?.data?.count && (
            <span
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 6px',
                borderRadius: '12px',
                background: '#F4F7FE',
                color: '#707EAE',
                fontSize: '12px',
                textTransform: 'lowercase',
              }}
            >
              {props.data.count}
            </span>
          )}
        </div>
      </components.Option>
    );
  };

  return (
    <div className={`${wrapperClassName}`}>
      {label && (
        <label
          htmlFor={id}
          className={`mb-[4px] ml-[16px] text-[14px] font-[500] text-gray-900 ${labelClassName} ${
            state === 'gray'
              ? 'text-gray-900'
              : state === 'success'
              ? 'text-green-700'
              : state === 'error'
              ? 'text-red-700'
              : ''
          }`}
        >
          {label}
        </label>
      )}
      <CreatableSelect
        inputValue={inputValue}
        isMulti
        value={val}
        options={options}
        className={`b-multi-base flex min-w-[250px] appearance-none items-center rounded-[16px] border border-secondaryGrey-500 bg-transparent bg-no-repeat px-1 text-[14px] font-[500] text-gray-700 outline-none placeholder:text-gray-500
          ${inputClassName} ${size === 'md' ? 'py-[3px]' : 'py-[1px]'} ${
            disabled === true
              ? 'disabled !border-secondaryGrey-300 !bg-secondaryGrey-300 !text-secondaryGrey-300 placeholder:!text-secondaryGrey-300'
              : state === 'error'
              ? '!border-red-500 !text-red-600 placeholder:!text-red-400'
              : state === 'success'
              ? '!border-green-500 !text-green-600 placeholder:!text-green-400'
              : state === 'gray'
              ? '!placeholder:text-purple-700 !border-secondaryGrey-600 !text-purple-900'
              : ''
          }`}
        onChange={(data) => {
          // @ts-ignore
          onChange?.(data, name);
        }}
        onInputChange={(newValue) => setInputValue(newValue)}
        placeholder={placeholder}
        styles={styles}
        isDisabled={disabled}
        isClearable={false}
        onKeyDown={handleKeyDown}
        menuIsOpen={
          options.findIndex((option) => option.label.includes(inputValue)) > -1
            ? undefined
            : false
        } // Скрыто создание, если нет в списке
        components={{ Option }}
      />
      {!!bottomText && (
        <p
          className={`ml-[16px] mt-[4px] text-[12px] font-[500] text-gray-500 ${bottomTextClassName} ${
            state === 'success'
              ? 'text-green-500'
              : state === 'error'
              ? 'text-red-500'
              : ''
          }`}
        >
          {bottomText}
        </p>
      )}
      {!!errorText && (
        <p
          className={`ml-[16px] mt-[4px] text-[12px] font-[500] text-gray-500 ${bottomTextClassName} text-red-500`}
        >
          {errorText}
        </p>
      )}
    </div>
  );
};
